var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseModal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseModal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icCloseModal",
    transform: "translate(0.660000, 0.660000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.17133513,7.4100348 L14.4552097,2.1261539 C14.9415968,1.6397663 14.9415968,0.8511783 14.4552097,0.3648603 C13.9688227,-0.1215273 13.1803052,-0.1215273 12.6939182,0.3648603 L7.40997393,5.6488107 L2.12602963,0.3647907 C1.63964263,-0.1215969 0.851125125,-0.1215969 0.364738125,0.3647907 C-0.121579375,0.8511783 -0.121579375,1.6397663 0.364738125,2.1260843 L5.64868233,7.4099652 L0.364738125,12.6939157 C-0.121579375,13.1803033 -0.121579375,13.9688913 0.364738125,14.4552093 C0.851125125,14.9415969 1.63964263,14.9415969 2.12602963,14.4552093 L7.40997393,9.1712588 L12.6939182,14.4552093 C13.1802356,14.9415969 13.9688227,14.9415969 14.4552097,14.4552093 C14.9415968,13.9688217 14.9415968,13.1803033 14.4552097,12.6939157 L9.17133513,7.4100348 Z",
    id: "icCloseModal"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseModal);
export default __webpack_public_path__ + "static/media/icCloseModal.0ef081566f74b5e32db04503bc612f43.svg";
export { ForwardRef as ReactComponent };